import React from "react";
import "../styles/legal.css";

export default function Terms() {
  return (
    <main className="privacy-page">
      <section className="privacy-hero">

        <h1 className="privacy-title">
          Terms of Use
        </h1>

        <p className="privacy-intro">
          Please read these Terms of Use ("Terms") carefully before using
          the website operated by Synergistic Intelligence® LLC ("SI," "we,"
          "us," or "our"). By accessing or using our website, the Flow
          Identity Assessment ("FIA"), or enrolling in the Flow Journey, you
          agree to be bound by these Terms. If you do not agree, please do
          not use our Services.
        </p>

        <p className="privacy-intro">
          These Terms apply to the SI website only. Once you gain access to
          Circle (available after enrolling in the Flow Journey), your use
          of Circle is governed separately by Circle's own terms of service,
          in addition to the Flow Journey Agreement you sign there.
        </p>

        <p className="privacy-date">
          Effective Date: August 25, 2026
          <br />
          Last Updated: August 25, 2026
        </p>
      </section>


      <section className="privacy-content">

        <TermsSection title="1. Eligibility">
          <p>
            You must be at least 18 years old to use our Services. By using
            our Services, you represent that you meet this requirement.
          </p>
        </TermsSection>


        <TermsSection title="2. Our Services">

          <p>Through our website, you can:</p>

          <ul>
            <li>Learn about Synergistic Intelligence and our approach</li>
            <li>Take the Flow Identity Assessment (FIA)</li>
            <li>
              Depending on your FIA results, you may be eligible for a free
              copy of a Synergistic Intelligence book, written by the
              founders, and/or other digital resources such as audio content
            </li>
            <li>Book a meeting with our team via Calendly or a similar scheduling tool</li>
            <li>Enroll and pay for the Flow Journey program</li>
            <li>Access Circle (community platform) after enrollment</li>
          </ul>

        </TermsSection>


        <TermsSection title="3. Intellectual Property">

          <p>
            All content on our website, including but not limited to text,
            graphics, the FIA and its methodology, published books (Quantum
            Emergence, Synergistic Intelligence, Flow and forthcoming
            titles), the Flow Identity Journal, audio content, and the
            Synergistic Intelligence® name and mark, is the property of SI
            or its licensors and is protected by copyright, trademark, and
            other intellectual property laws.
          </p>

          <p>You may not:</p>

          <ul>
            <li>
              Copy, reproduce, distribute, or share any assessment
              materials, results methodology, Flow Journey Guide content, or
              other SI materials, whether obtained through the website or
              Circle
            </li>
            <li>Use the Synergistic Intelligence™ name or mark without our prior written consent</li>
            <li>
              Reverse-engineer, resell, or repurpose the FIA or any related
              materials for commercial or personal use
            </li>
          </ul>

          <p>
            Any resources made available for download (such as the Flow
            Journey Guide preview) are licensed to you for personal,
            non-commercial use only, and remain SI's property.
          </p>

        </TermsSection>


        <TermsSection title="4. Payment and Enrollment">

          <p>
            Enrollment in the Flow Journey requires a one-time payment,
            processed through the Circle via Stripe. By enrolling, you
            authorize us to charge your provided payment method for the
            applicable fee.
          </p>

          <p>
            Upon graduation from the Flow Journey, you will receive the Flow
            Identity Journal as a gift purchased by SI through Amazon. You
            are responsible for coordinating delivery directly with Amazon
            once the gift is sent.
          </p>

          <p>
            Refunds and cancellations for the Flow Journey are governed by
            the Flow Journey Agreement, which you review and sign separately
            on Circle upon registration.
          </p>

        </TermsSection>


        <TermsSection title="5. User Conduct">

          <p>You agree not to:</p>

          <ul>
            <li>Misuse, disrupt, or attempt to gain unauthorized access to our website or systems</li>
            <li>Submit false, misleading, or spam entries through the FIA or any forms on our website</li>
            <li>Harass, abuse, or harm other users, SI team members, or the SI community</li>
            <li>Copy, scrape, or reproduce any intellectual property described in Section 3</li>
            <li>Use our Services for any unlawful purpose</li>
          </ul>

          <p>
            We reserve the right to suspend or terminate your access to our
            Services if we determine, in our discretion, that you have
            violated these Terms.
          </p>

        </TermsSection>


        <TermsSection title="6. The Flow Identity Assessment (FIA) — Disclaimer">

          <p>
            The FIA is a self-assessment tool intended to provide insight
            and personal reflection. It is not a clinical, medical,
            psychological, or diagnostic instrument. Results are provided
            for informational and developmental purposes only and should not
            be relied upon as professional advice.
          </p>

        </TermsSection>


        <TermsSection title="7. Third-Party Services">

          <p>
            Our website may link to or integrate with third-party services,
            including Stripe, Amazon, Calendly, Google Meet, Substack,
            YouTube and Circle. We are not responsible for the content,
            policies, or practices of these third parties. Your use of these
            services is subject to their own terms and privacy policies.
          </p>

        </TermsSection>


        <TermsSection title="8. Disclaimers">

          <p>
            Our Services are provided "as is" and "as available," without
            warranties of any kind, whether express or implied. We do not
            guarantee that the FIA, Flow Journey, or any other Service will
            meet your expectations, be uninterrupted, or be error-free.
          </p>

        </TermsSection>


        <TermsSection title="9. Limitation of Liability">

          <p>
            To the fullest extent permitted by law, SI and its founders,
            employees, and affiliates shall not be liable for any indirect,
            incidental, special, or consequential damages arising from your
            use of, or inability to use, our Services.
          </p>

        </TermsSection>


        <TermsSection title="10. Indemnification">

          <p>
            You agree to indemnify and hold harmless SI, its founders, and
            affiliates from any claims, damages, or expenses arising from
            your violation of these Terms or misuse of our Services.
          </p>

        </TermsSection>


        <TermsSection title="11. Termination">

          <p>
            We reserve the right to suspend or terminate your access to our
            Services at any time, with or without notice, for conduct that
            we believe violates these Terms or is otherwise harmful to SI or
            other users.
          </p>

        </TermsSection>


        <TermsSection title="12. Governing Law">

          <p>
            These Terms are governed by the laws of the State of California,
            without regard to its conflict of law provisions. Any disputes
            arising from these Terms or your use of our Services shall be
            resolved in the courts located in San Jose, California.
          </p>

        </TermsSection>


        <TermsSection title="13. Changes to These Terms">

          <p>
            We may update these Terms from time to time. Continued use of
            our Services after changes are posted constitutes your
            acceptance of the revised Terms. We will update the "Last
            Updated" date above accordingly.
          </p>

        </TermsSection>


        <TermsSection title="14. Contact Us">

          <ul>
            <li>Alec Lance — <a href="mailto:alec@synergisticintelligence.com">alec@synergisticintelligence.com</a></li>
            <li>Stan Cross — <a href="mailto:stan@synergisticintelligence.com">stan@synergisticintelligence.com</a></li>
          </ul>

          <p>
            Synergistic Intelligence® LLC
            <br />
            San Jose, California, USA
          </p>

        </TermsSection>


      </section>
    </main>
  );
}


function TermsSection({ title, children }) {
  return (
    <article className="privacy-section">

      <h2>
        {title}
      </h2>

      <div className="privacy-body">
        {children}
      </div>

    </article>
  );
}